import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import util from '@/util/util'
import constants from '@/util/constants'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

let routes = new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/login',
      component: (resolve) => require(['@/components/system/login/login.vue'], resolve)
    },
    {
      path: '/common',
      component: (resolve) => require(['@/components/common/main.vue'], resolve),
      redirect: 'common/home',
      children: [
        {
          path: 'home',
          component: (resolve) => require(['@/components/common/home.vue'], resolve)
        },
        {
          path: 'changePassword',
          component: (resolve) => require(['@/components/system/changePassword/changePassword.vue'], resolve)
        }
      ]
    },
    {
      path: '/system/loginForgetPassword',
      component: (resolve) => require(['@/components/system/login/loginForgetPassword.vue'], resolve)
    }
  ]
})
routes.beforeEach((to, from, next) => {
  if (Vue.prototype.$myresource === undefined) {
    Vue.prototype.$myresource = util.getSessionInfo('resource')
  }
  axios({
    url: '/static/config.json'
  }).then(function (result) {
    if (window.localStorage) {
      window.localStorage.setItem('IP', result.data.IP)
      window.localStorage.setItem('PORT', result.data.PORT)
      window.localStorage.setItem('PROTOCOL', result.data.PROTOCOL)
      window.localStorage.setItem('PROTOCOL_WEBSOCKET', result.data.PROTOCOL_WEBSOCKET)
      window.localStorage.setItem('PROJECT', result.data.PROJECT)
      constants.JS_CONTEXT = window.localStorage.getItem('PROTOCOL') + '://' +
        window.localStorage.getItem('IP') + ':' +
        window.localStorage.getItem('PORT') + '/' +
        window.localStorage.getItem('PROJECT')
      if (!util.getBrowerInfo().versions.mobile || util.getBrowerInfo().versions.iPad) {
        // if (!util.getBrowerInfo().versions.mobile) {
        window.location.replace(result.data.PC_SITE)
      } else {
        next()
      }
    } else {
      alert('当前浏览器不支持localStorage，请升级版本')
    }
  }).catch(function (err) {
    alert(err)
  })
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js